import { useMutation } from "react-query";

import axios from "axios";

import { MAP_SERVICE_ADDRESS } from "../../../constants/app.constants";

const API_URL = `${MAP_SERVICE_ADDRESS}`;

export const GetFacilitiesEnvelopeKey = "facilities-envelope";

interface FacilitiesBboxRequest {
  wellId: string;
  facilityIds: string[];
}

export default function useMutateFacilitiesEnvelope() {
  const fetchFacilitiesEnvelope = async (request: FacilitiesBboxRequest) => {
    if (!request.wellId || !request.facilityIds || request.facilityIds.length === 0) {
      return Promise.resolve(null);
    }
    const response = await axios.post<{
      minX: number;
      minY: number;
      maxX: number;
      maxY: number;
    }>(`${API_URL}/map/envelope/facilities`, request);
    if (response.status !== 200) {
      return null;
    }
    return response?.data;
  };
  return useMutation([GetFacilitiesEnvelopeKey], (request: FacilitiesBboxRequest) =>
    fetchFacilitiesEnvelope(request)
  );
}
